import React, { useEffect } from "react";
import PropTypes from "prop-types";

// Sections
import { 
  MagazineSection,
  VideoSection,
  PromoBlockSection,
  PromoSingleSection,
  QuoteBlockSection,
  IconBlockSection,
  BenefitCtaBlockSection,
  MultiColumnSection
} from "@home/components";

const Home = ({sections, hideCtas}) => {

  useEffect(() => {
    if (document.documentMode) resizeIEImages();
  }, []);

  // many images are using object-fit: cover to allow the different types (and dimensions) of images
  // Fix for IE distorting images
  const resizeIEImages = () => {
    jQuery('#home-content img.ie-resize').each(function(){
      var t = jQuery(this),
          s = 'url(' + t.attr('src') + ')',
          p = t.parent(),
          d = jQuery(`<div class="img"></div>`);
      p.append(d);
      d.css({
          'height'                : t.css('height'),
          'background-size'       : 'cover',
          'background-repeat'     : 'no-repeat',
          'background-position'   : '50% 20%',
          'background-image'      : s
      });
      t.hide();
    });
  }

  // Filter out sections that should be hidden for paying members
  if (hideCtas) {
    sections = sections.filter(section => section.type !== 'cta');
  }

  const components = {
    'magazine'      : MagazineSection,
    'video'         : VideoSection,
    'promo'         : PromoBlockSection,
    'promo-single'  : PromoSingleSection,
    'quote'         : QuoteBlockSection,
    'multi-column'  : MultiColumnSection,
    'icon'          : IconBlockSection,
    'cta'           : BenefitCtaBlockSection,
  }

  // Set background colour, depends on set colour and section type
  const backgroundColourDetails = [
    {key: 'magazine', defaultWhite: true},
    {key: 'video', defaultWhite: false},
    {key: 'icon', defaultWhite: false},
    {key: 'promo', defaultWhite: true},
    {key: 'promo-single', defaultWhite: true},
    {key: 'quote', defaultWhite: true},
    {key: 'multi-column', defaultWhite: false},
  ]
 
  for (let i = 0; i < sections.length; i++) {
    let section = sections[i]
    let colourDetail = backgroundColourDetails.find((type) => type.key == section.type)
    section.bgColour = 'white'
    if (colourDetail) {
      section.bgColour = section.colour;
      // Default background is white instead of the accent colour
      if (colourDetail.defaultWhite) {
        section.bgColour = section.bgColour == 'white' ? 'grey' : 'white'
      }
    }
  }

  // Set section margins - depends on background colour of surrounding sections
  for (let x = 0; x < sections.length; x++) {
    let section = sections[x]
    if (x == 0) {
      section.topMargin = 'pt-25 pt-md-3 pt-lg-5'
    } else {
      section.topMargin = (section.bgColour == sections[x-1].bgColour) ? 'pt-25 pt-md-2 pt-lg-3' : 'pt-3 pt-md-3 pt-lg-6'
    }

    if (x + 1 == sections.length) {
      section.bottomMargin = 'pb-25 pb-md-4 pb-lg-5'
    } else {
      section.bottomMargin = (section.bgColour == sections[x+1].bgColour) ? 'pb-25 pb-md-2 pb-lg-3' : 'pb-3 pb-md-3 pb-lg-6'
    }
  }

  return (
    <div>
      {sections.map((section) => {
        let Component = components[section.type] 
        return <Component section={section} key={section.id} />
      })}
    </div>
  );
}

Home.propTypes = {
  sections: PropTypes.array.isRequired,
  hideCtas: PropTypes.bool.isRequired
}

export default Home;
